import styled from "styled-components";
import { ContentContainer, SectionContainer } from "components";

const AppContent = ({ children = [] }) => {
  return (
    children
  )
}

export default AppContent;